module.exports = __webpack_public_path__ + "static/assets/e078c356fc8a9e146e4f76f1cc4b9319.png";